module.exports = {
    projectName:"天下事有难易乎",
    title: 'frame.systmeTitle',
    //设置主题样式
    themeName:'default',
    //分页的设置
    defaultPageSize:10,
    //默认每页显示的记录数
    defaultPageList:[10,15,30,50,100],
    //默认table的高度，显示10行数据没有滚动条的情况
    defaultGridHeight:((10+1)*30+39)+"px",
}